(function($, undefined) {
	
	'use strict';
	var formValidator;
	var tools;
    var utilPopupOpenPopup;
    var utilPopupClosePopup;
	var datepicker;
	var promoTypeSelect;
	var updateCCInfosBtn;
	var jobImgBtn;
	var attendedEventCheckbox;
	var allAttendedEventCheckbox;
	var applyCreditPopupBtn;
	var applyCreditConfirmBtn;
	var resendJobInvoiceBtn;
	var formatLocationFields;
	var futureEventSelector;

    var mouseIsDown = false;
    var resizeData = {};

	var initDatepickers = function() {
        datepicker.each(function() {
            var options;
            var t = $(this);
            var val = t.data('date');
            var name = t.attr('name');
            var lang = t.data('lang');
            var format = t.data('date-format');
            var noPast = t.data('beatpicker-disable');
            var disableD = t.data('disable-day');
            var disableM = t.data('disable-month');
            var disableY = t.data('disable-year');

            if (typeof noPast !== "undefined") {
                options = {
                    dateInputNode: t,
                    dateFormat: {
                        separator: '/',
                        format: format ? format.split(',') : []
                    },
                    modules: {
                        gotoDate: false,
                        today: false,
                        clear: false,
                        icon: false
                    },
                    disablingRules: [{from:[parseInt(disableY),parseInt(disableM),parseInt(disableD)],to:'<'}]
                };
            }
            else {
                options = {
                    dateInputNode: t,
                    dateFormat: {
                        separator: '/',
                        format: format ? format.split(',') : []
                    },
                    modules: {
                        gotoDate: false,
                        today: false,
                        clear: false,
                        icon: false
                    }
                };
            }
            

            if (lang === 'fr') {
                options.daysSimple = ["D", "L", "M", "M", "J", "V", "S"];
                options.daysFull = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
                options.monthsSimple = ["Jan", "Fév", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"];
                options.monthsFull = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
            } else if (lang === 'en') {
                options.daysSimple = ["S", "M", "T", "W", "T", "F", "S"];
            }

            var beatpicker = new BeatPicker(options);
            var inputCtn = t.parents('.input-ctn');
            var pickerWrap = t.parents('.datetime-wrap');
            var resetter = pickerWrap.find('.datepicker-reset');
            if (val !== '') {
                beatpicker.selectDate(val);
                beatpicker.setDate(val);
                resetter.parent().removeClass('hide');
            } else {
                beatpicker.setDate(new Date());
            }
            t.parent().before(t);
            t.parent().find('.input-parent').remove();

            beatpicker.on('select', function(data, a, b) {
                formValidator.validateField(t);
                $('input[name="' + name + 'Day"]', inputCtn).val(data.dateObj.getDate());
                $('input[name="' + name + 'Month"]', inputCtn).val(data.dateObj.getMonth());
                $('input[name="' + name + 'Year"]', inputCtn).val(data.dateObj.getFullYear());
                resetter.parent().removeClass('hide');
            });
            resetter.on('click', function() {
                beatpicker.reset();
                $('input[name="' + name + 'Day"]', inputCtn).val('');
                $('input[name="' + name + 'Month"]', inputCtn).val('');
                $('input[name="' + name + 'Year"]', inputCtn).val('');
                $('.form-input[name="' + name + 'Hour"]', pickerWrap).val('');
                $('.form-input[name="' + name + 'Minute"]', pickerWrap).val('');
                resetter.parent().addClass('hide');
            });
		});
	};

	var checkPromoType = function() {
		var t = $(this);
		var form = t.closest('form');
        var v = t.val();

		if (v !== '0' && v !== '') {
			form.find('.input-ctn.value-input-ctn').removeClass('hidden').find('.form-input').addClass('required');
		} else {
			form.find('.input-ctn.value-input-ctn').addClass('hidden').find('.form-input').removeClass('required');
		}
        if (v === '1' || v === '3') {
            form.find('.value2-input-ctn').removeClass('hidden');
        } else {
            form.find('.value2-input-ctn').addClass('hidden');
        }
        //Added for group
        if (v === '7') {
			form.find('.input-ctn.value-input-ctn-group').removeClass('hidden').find('.form-input').addClass('required');
		} else {
			form.find('.input-ctn.value-input-ctn-group').addClass('hidden').find('.form-input').removeClass('required');
		}
	};

	var updateCCInfos = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var ccError = form.find('.js-form-error-message.cc-error');
		var error = form.find('.js-form-error-message.error-occured');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			btn.addClass('disabled');

			var url = '/action/pmiUpdatePayment';

			url += '?id=' + form.find('input[name=id]').val();
			url += '&ccCard=' + encodeURIComponent(form.find('input[name=ccCard]').val());
			url += '&expMM=' + form.find('select[name=expMM]').val();
			url += '&expYY=' + form.find('select[name=expYY]').val();
			url += '&cvv=' + encodeURIComponent(form.find('input[name=cvv]').val());

			if (form.find('input[name=sendInvoice]').prop('checked')) {
				url += '&sendInvoice=true';
			}

			var obj = ajax(url, function(response){
				if (response.indexOf('success') !== -1) {
					ccError.slideUp();
					error.slideUp();
                    window.location.reload();
				} else if (response.indexOf('Unable to process payment') !== -1) {
					error.slideDown();
					ccError.slideUp();
					btn.removeClass('disabled');
				} else {
					ccError.slideDown();
					error.slideUp();
					btn.removeClass('disabled');
				}
			},true);
		}
	};

	var updateJobImgChoice = function() {
		var t = $(this);
		var input = t.closest('.create-job-image-ctn').find('input[name^=field0]');
		// var input = t.closest('.create-job-image-ctn').find('input[name=field1]');
		var popup = t.closest('.file-preview-picker-popup');
		var itemSelected = $('.file-preview-picker-item:not(.folder).selected', popup);
		var fileUrl = itemSelected.attr('data-file-url');
		var value = itemSelected.attr('data-value');
		var fullPathValue = fileUrl + '/' + value;

		input.val(fullPathValue);
	};
    
    var participantRefunded = function() {
		var url = '/action/pmiSignupRefunded';
		url += '?id=' + $(this).val();
		url += '&refunded=' + $(this).prop('checked');

		ajax(url, function(response) {}, true);
    };

	var pmiAttended = function() {
		var id = $(this).val();
		var checked = $(this).prop('checked');

		var url = '/action/pmiAttended';
		url += '?id=' + id;
		url += '&attended=' + checked;

		ajax(url, function(response) {}, true);
	};

	var pmiAllAttended = function() {
		var t = $(this);
		var checked = t.prop('checked');
		var table = t.closest('table');

		table.find(attendedEventCheckbox).each(function() {
			if ($(this).prop('checked') !== checked) {
				$(this).trigger('click');
			}
		});
	};

	var applyCreditValidate = function() {
		var form = $(this).closest('.js-form');

		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			form.find('.open-popup-btn').trigger('click');
		}
	};

	var applyCredit = function() {
		var btn = $(this);
		var form = btn.closest('.js-form');
		var input = form.find('input[name=credit]');

		btn.addClass('disabled');

		var url = '/action/pmiAttended';
		url += '?id=' + form.attr('data-id');
		url += '&credit=' + input.val();

		var obj = ajax(url, function(response) {
			btn.removeClass('disabled');

			if (response.indexOf('success') !== -1) {
				btn.closest('.popup').find('.close-popup-btn').trigger('click');
				input.val('').removeClass('error').removeClass('success').removeClass('has-value');
				$('.success-msg.credit').slideDown();

				setTimeout(function() {
					$('.success-msg.credit').slideUp(function() {});
				}, 5000);
			}
		},true);
	};

	var resendJobInvoice = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var input = form.find('input[name=paymentId]');

		var url = '/action/shopResendPaymentEmail?jobEmail=true';
		url += '&id=' + input.val();

		var obj = ajax(url, function(response) {
			if (response.indexOf('success') !== -1) {
				input.val('').removeClass('error').removeClass('success').removeClass('has-value');
				$('.success-msg.resend-job-email').slideDown();

				setTimeout(function() {
					$('.success-msg.resend-job-email').slideUp();
				}, 5000);
			}
		},true);
	};

	var copyUrlToClipboard = function() {
		var id = $(this).attr('data-id');
		var copyText = document.getElementById(id);
		var popup = $('.popup-outer[data-id="pmi-event-url-copied"]');

		copyText.select();
		document.execCommand('copy');
		popup.find('.copied-url').html(copyText.value);
		popup.addClass('open');

		setTimeout(function() {
			popup.removeClass('open');
		}, 1500);
	};
    
    var formatLocation = function(){
        var json = {};
        formatLocationFields.each(function(){
            var t = $(this);
            json[t.attr("name")] = t.val();
        });
        $(".final-location").val(JSON.stringify(json));
        
        setTimeout(formatLocation, 1000);
    };
    
    var previewLocationImage = function () {
        if (!$('.location-image-preview')[0]) {
            return false;
        }
        
        $('.location-image-preview').each(function(i) {
            var newSrc = $('.location-field-img-picker input')[i].value || "";
            var curSrc = this.getAttribute('data-src') || "";
            
            if (newSrc !== curSrc) {
                this.innerHTML = '<img src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });
        
        setTimeout(previewLocationImage, 1000);
    };

    var loadPromoEvents = function () {
        var select = $('.promocode-event-select');
        var eId = select.attr('data-extra');
        var url = '/action/pmiEvent';

        var _getEvents = function (extraParam, groupName, callback) {
            ajax(url + extraParam, function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    if (json.length > 0) {
                        var builder = '';
                        builder += '<optgroup label="' + groupName + '">';
                        for (var i in json) {
                            var event = json[i];
                            var option = '<option value="' + event.id + '"';

                            if (eId !== undefined && eId !== '' && event.id == eId) {
                                option += ' selected=""';
                            }
                            option += '>' + event.name + ' - ' + event.timeStart + '</option>';
                            builder += option;
                        }
                        builder += '</optgroup>';
                        select.append(builder);
                    }
                } catch (e) {
                    console.log('error: ' + e);
                }
                if (typeof callback === "function") {
                    callback();
                }
            }, true);
        };

        _getEvents('?getFutureEvents=true', select.attr('data-future'), function () {
            _getEvents('?getPastEvents=true', select.attr('data-past'));
        });
    };

    var loadPromoProducts = function () {
        var select = $('.promocode-product-select');
        var id = select.attr('data-extra');

        ajax('/action/shopJSONProducts?json=true', function (response) {
            try {
                var json = JSON.parse(response.trim());
                if (json.length > 0) {
                    var builder = '';
                    for (var i in json) {
                        var obj = json[i];
                        var option = '<option value="' + obj.id + '"';

                        if (id !== undefined && id !== '' && obj.id == id) {
                            option += ' selected=""';
                        }
                        option += '>' + obj.name + '</option>';
                        builder += option;
                    }
                    select.append(builder);
                }
            } catch (e) {
                console.log('error: ' + e);
            }
        }, true);
    };
    
    var sortByQuery = function(e) {
        var it = e.currentTarget || this;
        var prefix = $(it).closest(".sortquery").attr("data-param-prefix");
        var q = setQuery(prefix ? prefix + "SortBy" : "sortBy", it.getAttribute("data-sort-by"));
        q = setQuery(prefix ? prefix + "SortOrder" : "sortOrder", it.getAttribute("data-sort-order"), q);
        window.location.search = "?" + q;
    };

    var validateEventForm = function (e) {
        var it = e.currentTarget || this;
        var $form = $(it).closest('form');
        
        // Process extra fields
        $form.find('.multichoice-field').each(function(i, el) {
            if (el.checked) {
                var $ctn = $(document).find('[data-toggle-id="' + $(el).attr('data-toggle-id') + '"]');
                var values = $ctn.find('[name="' + el.name + 'Values"]').val() || "";
                var require = $ctn.find('[name="' + el.name + 'Required"]').val();
                var type = $ctn.find('[name="' + el.name + 'Type"]').val();
                
                if (values.replace(/ ;/g, '') !== '' || type === 'text') {
                    // Format the values before saving
                    var vA = values.split(';');
                    var vB = [];
                    
                    Array.prototype.forEach.call(vA, function(v) {
                        if (v.trim() !== '') {
                            vB.push(v.trim());
                        }
                    });
                    // The values must be saved in this order: values_!_required_!_type
                    el.value = vB.join(';') + '_!_' + require + '_!_' + type;
                } else {
                    // The values field is empty or invalid
                    el.value = '';
                }
            } else {
                // The field is not active, the data then gets erased
                el.value = '';
            }
        });
        
        // Process adding guests option
        var field2 = $form.find('[name=field2]');
        if (field2.prop('checked')) {
            field2.val($form.find('[name=field2x]').val());
        }
        
        // Process extra pricing (aka price options)
        $form.find('.event-price-option').each(function(i, el) {
            // Deleting an option will make associated prices deleted so modification does not matter
            if (!$(el).hasClass('deleting')) {
                var s = [];
                $('.event-price-input', el).each(function(i, inp) {
                    // Having an id means the price is modified. Otherwise, in create mode, only create the price with a valid value
                    if (inp.value && $(inp).hasClass('success') || inp.id) {
                        var k = inp.getAttribute('data-extra') || '';
                        var id = inp.id || '';
                        // Empty value sets the price to be deleted in the backend
                        s.push(id.replace(/[\D_-]/g, '') + ':' + k + ':' + inp.value);
                    }
                });
                $('input[name^=priceIdsKeysValues]', el).val(s.join(';'));
            }
        });

        //Process add extra pricing (aka add price based on Options)
        $form.find('.event-add-price-option').each(function(i, el) {
            // Deleting an option will make associated prices deleted so modification does not matter
            if (!$(el).hasClass('deleting')) {
                var s = [];
                $('.event-add-price-input', el).each(function(i, inp) {
                    // Having an id means the price is modified. Otherwise, in create mode, only create the price with a valid value
                    if (inp.value && $(inp).hasClass('success') || inp.id) {
                        var k = inp.getAttribute('data-extra') || '';
                        var id = inp.id || '';
                        // Empty value sets the price to be deleted in the backend
                        s.push(id.replace(/[\D_-]/g, '') + ':' + k + ':' + inp.value);
                    }
                });
                $('input[name^=priceAddIdsKeysValues]', el).val(s.join(';'));
            }
        });
        
        // Validation
        try {
            var startDate = new Date($('[name=timeStartYear]').val() + '-' + (parseInt($('[name=timeStartMonth]').val()) + 1) + '-' + $('[name=timeStartDay]').val() + ' ' + $('[name=timeStartHour]').val() + ':' + $('[name=timeStartMinute]').val() + ':00');
            var endDate = new Date($('[name=timeEndYear]').val() + '-' + (parseInt($('[name=timeEndMonth]').val()) + 1) + '-' + $('[name=timeEndDay]').val() + ' ' + $('[name=timeEndHour]').val() + ':' + $('[name=timeEndMinute]').val() + ':00');
            if (startDate.getTime() > endDate.getTime()) {
                throw 'Bad time';
            }
            // Passed, event end time is after start time
            $('.event-date-error').slideUp(300);
            // Validate normal fields and submit the form
            tools.validateForm.call(it, []);
        } catch (err) {
            $('.event-date-error').slideDown(300);
        }
    };
    
    var validateEmailListForm = function(e) {
        var it = e.currentTarget || this;
        var emailListEl = $('[name=emailList]');
        var regex = /^(\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,4}\s*?,?\s*?)+$/;
        var currentDateTime = new Date();
        var validEmailList = true;
        
        if (emailListEl.hasClass('required')) {
            var emails = $('[name=emailList]').val().replace(/\s/g, '').split(",");
            for (var i = 0; i < emails.length; i++) {
                if (emails[i] == "" || !regex.test(emails[i])) {
                    $('.event-email-list-error').slideDown(300);
                    validEmailList = false;
                }
            }
        }
        if (validEmailList) {
            $('.event-email-list-error').slideUp(300);
            if (currentDateTime.getFullYear() < $('[name=scheduledTimeYear]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getFullYear() == $('[name=scheduledTimeYear]').val() && currentDateTime.getMonth() < $('[name=scheduledTimeMonth]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getMonth() == $('[name=scheduledTimeMonth]').val() && currentDateTime.getDay() < $('[name=scheduledTimeDay]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getDay() == $('[name=scheduledTimeDay]').val() && currentDateTime.getHours() < parseInt($('[name=scheduledTimeHour]').val())) {
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else {
                $('.event-email-list-date-error').slideDown(300);
            }
        }
    };
    
    var imagePickerSlickSliderInit = function(event, slick, currentSlide) {
        var slides = slick.$slides;
        slides = $(slides).filter('.calendar-home-event-infos-ver2 .slick-active');
        if (slides.length > 0 && slides.width() !== 0) {
            var dataid;
            var imagePicker = $(slides).find('.background-picker-settings-ctn');
            if (imagePicker.length > 0) {
                dataid = $(imagePicker).attr("data-imageid");
                if ($('.calendar-image-picker .background-picker-settings-ctn[data-imageid="' + dataid + '"]').length > 0) {
                    $(imagePicker).detach();
                } else {
                    $(imagePicker).detach().appendTo(".calendar-image-picker");
                    var ev = $._data($('div > .picker-popup-button', $(imagePicker)), 'events');
                    if (!ev || !ev.click) {
                        initTools(imagePicker);
                    }
                }
            } else {
                var image = $(slides).find('.img');
                if (image.length > 0) {
                    dataid = $(image).attr("data-id");
                }
            }
            if (dataid !== undefined) {
                if (!$('.calendar-image-picker .background-picker-settings-ctn .picker-popup').is(":visible")) {
                    var current = $('.calendar-image-picker .background-picker-settings-ctn[data-imageid="' + dataid + '"]').show();
                    $('.calendar-image-picker .background-picker-settings-ctn').not(current).hide();
                }
            }
        }
    };
    
    var addEventPdu = function (e) {
    	var t = $(this);
    	var innerCtn = t.closest('.pdu-ctn').find('.pdu-ctn-inner');
    	var inputs = $('.pdu-inputs-ctn')[0];
    	var clone = $(inputs).clone(true);

    	innerCtn.append(clone);
        $('.form-input', clone).val('').removeClass('has-value success error');
    };

    function fetchEvents(e, th) {
        var t = (th !== undefined) ? th : $(this);
        var eId = t.attr("data-extra");

        if (!futureEventSelector.hasClass("unloaded")) {
            ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    for (var j in json) {
                        var event = json[j];
                        var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                        if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                            option.attr("selected", "true");
                        }
                        futureEventSelector.append(option);
                    }
                    futureEventSelector.addClass("unloaded");
                } catch (e) {
                    console.error(e);
                }
            }, true);
        }
    }
    
    var editExpense = function (e) {
        if (e) e.preventDefault();
        
        var form = document.getElementById(this.getAttribute("data-form")),
            inputs = form.elements,
            data = $(this).closest("tr").data(),
            name;
    
        $.each(inputs, function(i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = data.hasOwnProperty(name) && data[name] === el.value;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                }
                if (el.type === "file") {
                    var $label = $(el).closest(".form-input-upload-input-label");
                    $label.find(".form-input-upload-input-label-value").text($label.attr("data-default-value"));
                }
            }
        });
        
        $(form).addClass("editing").slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top
        }, 300);
    };
    
    var resetExpenseForm = function (e) {
        var form = $('#event-expense-form');
        if (form.hasClass('editing')) {
            e.stopImmediatePropagation();
            form[0].reset();
            form.find('input[name="id"]').val('');
            form.find('.form-input-upload-input-label').each(function () {
                $(this).find('.form-input-upload-input-label-value').text($(this).attr('data-default-value'));
            });
            form.removeClass('editing');
        }
    };
    
    var resetEmailListForm = function(e) {
        var form = $('#event-email-list-form');
        if (form.hasClass('editing')) {
            e.stopImmediatePropagation();
            form[0].reset();
            form.find('input[name="id"]').val('');
            form.find('.form-input-upload-input-label').each(function () {
                $(this).find('.form-input-upload-input-label-value').text($(this).attr('data-default-value'));
            });
            form.removeClass('editing');
            form.find('.element-to-toggle[data-toggle-id="emailList"]').slideDown();
        }
    };
    
    var editEmailList = function (e) {
        if (e) e.preventDefault();
        
        var form = document.getElementById(this.getAttribute("data-form")),
            inputs = form.elements,
            data = $(this).closest("tr").data(),
            name;
    
        $.each(inputs, function(i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (name === "type") {
                    if (data.emaillist === "participants") {
                        if (el.value === "reminder") {
                            el.checked = true;
                            $(el).triggerHandler("click");
                        } else {
                            el.checked = false;
                        }
                    } else {
                        if (el.value === "list") {
                            el.checked = true;
                            $(el).triggerHandler("click");
                        } else {
                            el.checked = false;
                        }
                    }
                    //$(el).triggerHandler("change");
                } else if (name === "emaillist") {
                    el.value = data.emaillist !== "participants" ? data[name] : "";
                } else if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = data.hasOwnProperty(name) && data[name] === el.value;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                }
            }
        });
        
        $(form).addClass("editing").slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top - $('.site-header').height()
        }, 300);
    };
    
    var eventTypeChange = function(e) {
        // Remove "required" from price inputs if the event type is display only and price hidden
        var array = ['3', '4'];
        var it = e.currentTarget || this;
        var $form = $(it).closest('.create-event-form');
        
        if (array.indexOf($('.form-input[name=eventType]', $form).val()) > -1) {
            $('.form-input[name=maxParticipants], .form-input[name=priceAll], .form-input[name=priceMember]', $form)
                .removeClass('required')
                .siblings('.form-input-label').each(function() {
                    this.textContent = this.textContent.replace(/\*$/, '');
                });
        } else {
            $('.form-input[name=maxParticipants], .form-input[name=priceAll], .form-input[name=priceMember]', $form)
                .addClass('required')
                .siblings('.form-input-label').each(function() {
                    var label = this.textContent;
                    if (!label.endsWith('*')) {
                        this.textContent = label + '*';
                    }
                });
        }
    };
    
    function initFormBuilder() {
        const formEditor = $('.admin-forms-editor-fields');
        const formId = getQuery("formId");
        
        // Verify page
        if (!formEditor[0]) {
            return false;
        }
        // Fix sortable elements getting wrong offset while being dragged.
        // We need to set overflow:auto to the main container, and then change the overflow to initial why we start dragging an element.
        formEditor.css('overflow', 'auto');
        
        const fieldsetCtn = formEditor.find('.fieldsets');
        const fieldsetTemplate = formEditor.find('.fieldset.last')[0].outerHTML;
        const controlCtn = formEditor.find('.admin-forms-editor-fields-control');
        let fieldCount = 0;
        let currentEditFieldId;
        
        const toggleHighlightFieldset = function(off, noAdd) {
            // Highlighter on the fieldset for better visualization and to fix the issue with off target dragging 'helper'
            if (off) {
                fieldsetCtn.find('.fieldset').removeClass('ui-droppable-active');
                formEditor.css('overflow', 'auto');
                controlCtn.css('overflow', '');
            } else {
                fieldsetCtn.find('.fieldset' + (noAdd ? ':not(.last)' : '')).addClass('ui-droppable-active');
                formEditor.css('overflow', 'initial');
                controlCtn.css('overflow', 'initial');
            }
        };
        
        const resizeFieldClickHandler = function(e) {
            e.stopPropagation();
            mouseIsDown = true;
            const ctn = e.currentTarget.parentElement;
            resizeData = {
                target: ctn,
                startX: e.clientX,
                startWidth: ctn.clientWidth,
                parentWidth: ctn.parentElement.clientWidth - parseFloat($(ctn).css('margin-left')),
                fullWidth: $(ctn.parentElement).offset().left + ctn.parentElement.clientWidth
            };
            // Add resizing classes for styling
            $(resizeData.target).addClass('resizing');
            $('body').addClass('resizing-col');
        };
        
        const editFieldClickHandler = function(e) {
            e.preventDefault();
            e.stopPropagation();
            utilPopupOpenPopup.call(this, e);

            const ctn = $(this).closest('.input-ctn, .form-checkbox-ctn');
            const inp = ctn.find('.form-input, .form-check-input, .form-input-upload-input');
            const lbl = ctn.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value');
            
            currentEditFieldId = ctn.attr('id');
            $('.edit-field-name-input')
                .val(inp.attr('name'))
                .removeClass('error')
                .attr('disabled', 'true')
                .addClass('disabled');
            $('.edit-field-required-input').prop('checked', inp.hasClass('required'));
            $('.edit-field-mce-input').prop('checked', inp.hasClass('mce-enabled'));
            $('.edit-field-select-options-item:not(.new)').remove();
            $('.edit-field-select-options-item input').val('');
            
            if (!lbl[0]) {
                $('.edit-field-label-input').val(ctn.find('.text-content').text());
                $('.edit-field-name-input').parent().hide();
                $('.edit-field-required-input').parent().hide();
            } else {
                $('.edit-field-label-input').val(lbl.text());
                $('.edit-field-name-input').parent().show();
                $('.edit-field-required-input').parent().show();
            }
            
            if (inp.hasClass('textarea')) {
                $('.edit-field-mce-input').parent().show();
            } else {
                $('.edit-field-mce-input').parent().hide();
            }
            
            if (inp.hasClass('form-select')) {
                $('.edit-field-select-options').parent().show();
                const item = $('.edit-field-select-options-item.new');
                $('option:not(:empty)', inp).each(function() {
                    const clone = item.clone(true);
                    clone.insertBefore(item);
                    clone.removeClass('new').find('.add').remove();
                    clone.find('input').val(this.value);
                });
            } else {
                $('.edit-field-select-options').parent().hide();
            }
            
            if (inp.attr('type') === 'file') {
                $('.edit-field-accept-input').val(inp.attr('accept'))
                    .parent().show();
            } else {
                $('.edit-field-accept-input').parent().hide();
            }
        };
        
        // Inject data and build the fieldsets when editing an existing form
        // It should be done before initiating the event handlers
        if (formId) {
            const list = JSON.parse(fieldsetCtn.attr('data-array')) || [];
            const fieldElements = formEditor.find('.add-field-element');
            
            list.forEach(function(set) {
                const fieldset = fieldsetCtn.find('.fieldset.last');
                const ctn = fieldset.find('.inputs-ctn');
                
                fieldset.removeClass('last');
                // Clone "last" template
                fieldsetCtn.append(fieldsetTemplate);
                // Iterate field data
                set.fields.forEach(function(field) {
                    const el = fieldElements.filter('[data-ctn="' + field.type + '"]').clone(true);
                    // Append to inputs-ctn
                    ctn.append(el);
                    // Attributes and classes
                    el
                        .removeClass('add-field-element')
                        .addClass(field.spanClass)
                        .attr('data-span', field.spanClass)
                        .attr('id', randomIdMix(6));
                    // Values and labels
                    if (el.hasClass('text-ctn')) {
                        el.find('.text-content').text(field.label);
                    } else {
                        const inp = el.find('.form-input, .form-check-input, .form-input-upload-input');
                        const lbl = el.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value');
                        const isCheckbox = el.hasClass('form-checkbox-ctn');
                        
                        if (field.required) {
                            inp.addClass('required');
                        }
                        // Set input name and value
                        inp
                            .attr('name', field.name)
                            .attr('value', field.value);
                        // Set field label and required sign (*)
                        lbl.text(field.label);
                        // Set mce class for rich-text format
                        if (field.mceEnabled == true) {
                            inp.addClass('mce-enabled');
                        }
                        // Set select options
                        if (field.type === 'select' && field.items) {
                            inp.html('<option value=""></option>');
                            field.items.forEach(function(value) {
                                inp.append('<option value="' + value + '">' + value + '</option>');
                            });
                        }
                        // Set file input
                        if (field.type === 'upload' && field.accept) {
                            inp.attr('accept', field.accept);
                        }
                        // Resize button
                        el
                            .append('<div class="resize-field-handle">||</div>')
                            .find('.resize-field-handle')
                            .on('mousedown', resizeFieldClickHandler);
                    }
                    // Edit button
                    el
                        .append('<a class="edit-field-btn" data-id="edit-field-popup">' + makeSvgPencil() + '</a>')
                        .find('.edit-field-btn')
                        .on('mousedown', editFieldClickHandler);
                });
            });
        }
        
        // Initiate addable field draggable
        formEditor.find('.add-field-element').draggable({
            connectToSortable: '.fieldset>.inputs-ctn',
            opacity: 0.6,
            zIndex: 1,
            cursor: 'grabbing',
            helper: 'clone',
            revertDuration: 0,
            start: function(event, ui) {
                // Set helper's width otherwise the width would be auto
                ui.helper.width(this.clientWidth);
                toggleHighlightFieldset();
            },
            stop: function(event, ui) {
                toggleHighlightFieldset(true);
            }
        });
        
        // Initiate fieldset elements sortable in the main container
        fieldsetCtn.sortable({
            cursor: 'move',
            handle: '.fieldset-sort-handle',
            items: '.fieldset:not(.last)',
            scroll: false,
            start: function(event, ui) {
                toggleHighlightFieldset(false, true);
            },
            stop: function(event, ui) {
                toggleHighlightFieldset(true);
            }
        });
        
        // Initiate input fields sortable inside fieldset
        const sortableOption = {
            cursor: 'move',
            connectWith: '.inputs-ctn',
            scroll: false,
            activate: function(event, ui) {
                if (ui.sender) {
                    // Display remove zone when the dragged item is not "add-field-element"
                    formEditor.find('.remove-field-bin').addClass('ui-droppable-active');
                }
            },
            start: function(event, ui) {
                toggleHighlightFieldset();
            },
            stop: function(event, ui) {
                toggleHighlightFieldset(true);
                formEditor.find('.remove-field-bin').removeClass('ui-droppable-active');
            },
            over: function(event, ui) {
                $(this).parent().addClass('ui-sortable-hover');
            },
            out: function(event, ui) {
                $(this).parent().removeClass('ui-sortable-hover');
            },
            change: function(event, ui) {
                if (ui.placeholder && ui.placeholder.hasClass('text-ctn')) {
                    ui.placeholder.width(ui.placeholder.parent().width());
                }
            },
            receive: function(event, ui) {
                // Manipulate the received element
                if (ui.helper && ui.helper.hasClass('add-field-element')) {
                    // New field
                    ui.helper
                        .css('width', '')
                        .css('height', '')
                        .removeClass('add-field-element')
                        .attr('id', randomIdMix(6));
                    // Hanlde resizable method
                    if (!ui.helper.hasClass('text-ctn')) {
                        ui.helper.append('<div class="resize-field-handle">||</div>')
                            .find('.resize-field-handle').on('mousedown', resizeFieldClickHandler);
                    }
                    // Handle edit button
                    ui.helper.append('<a class="edit-field-btn" data-id="edit-field-popup">' + makeSvgPencil() + '</a>')
                        .find('.edit-field-btn').on('mousedown', editFieldClickHandler);
                }
                
                const ctn = $(this).closest('.fieldset');
                // Create new fieldset when a field is added in the last one (+ zone)
                if (ctn.hasClass('last')) {
                    const $new = $(fieldsetTemplate);
                    fieldsetCtn.append($new);
                    ctn.removeClass('last');
                    // Reinitialize sortable on the new element
                    $new.children('.inputs-ctn').sortable(sortableOption);
                    // Refresh the sortable items. Triggers the reloading of all sortable items, causing new items to be recognized.
                    fieldsetCtn.sortable('refresh');
                }
            },
            remove: function(event, ui) {
                // Remove current fieldset when it contains no fields
                if (!this.firstChild) {
                    $(this).closest('.fieldset').remove();
                }
            },
            update: function(event, ui) {
                // Generate field name, especially for checkbox and radio inputs. 
                // Auto-grouping: General rule is if they are placed next to another field with the same type, they take the name of that sibling.
                fieldCount = 0;
                // Ignore text-ctn (heading, description)
                formEditor.find('.inputs-ctn>*:not(.text-ctn)').each(function() {
                    const inputCtn = $(this);
                    let newName;
                    
                    if (inputCtn.hasClass('form-checkbox-ctn')) {
                        const isRadio = inputCtn.hasClass('radio-btn');
                        const sibling = inputCtn.prev();
                        if (sibling[0]) {
                            const isRadio2 = sibling.hasClass('radio-btn');
                            if (!isRadio && !isRadio2 || isRadio && isRadio2) {
                                const checkInp = sibling.find('.form-check-input');
                                newName = checkInp.attr('name');
                                if (checkInp.hasClass('required')) {
                                    inputCtn.find('.form-check-input').addClass('required');
                                }
                            }
                        }
                    }
                    if (!newName) {
                        fieldCount++;
                        newName = 'field' + fieldCount;
                    }
                    inputCtn.find('.form-input, .form-check-input, .form-input-upload-input').attr('name', newName);
                });
            }
        };
        fieldsetCtn.find('.fieldset>.inputs-ctn').sortable(sortableOption);
        
        // Initiate global resizable field handlers
        $('body').on('mouseup', function(e) {
            mouseIsDown = false;
            $(resizeData.target).removeClass('resizing');
            $('body').removeClass('resizing-col');
            resizeData = {};
        });
        $('body').on('mousemove', function(e){
            if (mouseIsDown) {
                // (Current mouse position - item starting position + item original width) / upper container width
                let x = (e.clientX - resizeData.startX + resizeData.startWidth) / resizeData.parentWidth * 100;
                let clazz = x < 22 ? 'five' : // 20 - 25
                            x < 27 ? 'four' : // 25 - 33.3
                            x < 41 ? 'three' : // 33.3 - 50
                            x < 66 ? '' : // 50 - 80, default is half
                            x < 90 ? 'four-fifth' : // 80 - 100
                            'full';
                $(resizeData.target)
                    .removeClass('full four-fifth three four five')
                    .addClass(clazz)
                    .attr('data-span', clazz);
            }
        });
        
        // Initiate remove bin
        // Inputs-ctn accept zone
        formEditor.find('.remove-field-bin>.inputs-ctn').sortable(sortableOption);
        // Fieldset accept zone
        formEditor.find('.remove-field-bin').droppable({
            accept: '.fieldset',
            tolerance: 'pointer',
            drop: function(event, ui) {
                ui.draggable.remove();
                // Refresh the sortable items. Triggers the reloading of all sortable items, causing new items to be recognized.
                fieldsetCtn.sortable('refresh');
            }
        });
        
        // Initiate right panel collapse button
        $('.collapse-panel', controlCtn).on('click', function(e) {
            const ctn = $(e.currentTarget).closest('.admin-forms-editor-fields-control');
            formEditor.toggleClass('collapsed');
            if (formEditor.hasClass('collapsed')) {
                ctn.find('.add-field-list').width(ctn.width());
                ctn.css('overflow', 'hidden');
            } else {
                setTimeout(function() {
                    ctn.find('.add-field-list').width('auto');
                    ctn.css('overflow', 'visible');
                }, 400);
            }
        });
        
        // Initiate actions in edit field popup
        $('.edit-field-select-options-item').on('click', '.add', function(e) {
            const item = $(e.delegateTarget);
            if (!item.find('input').val()) {
                return false;
            }
            const clone = item.clone(true);
            clone.insertBefore(item);
            clone.removeClass('new').find('.add').remove();
            item.find('input').val('');
        });
        $('.edit-field-select-options-item').on('click', '.del', function(e) {
            e.delegateTarget.parentElement.removeChild(e.delegateTarget);
        });
        $('.edit-field-select-options-item.new input').on('keypress', function(e) {
            // Enter to add
            if (e.keyCode === 13 || e.which === 13) {
                $(this).closest('.edit-field-select-options-item').find('.add').trigger('click');
            }
        });
        $('.edit-field-apply-btn').on('click', function(e) {
            const form = $(e.currentTarget).closest('.edit-field-form');
            const field = $('#' + currentEditFieldId);
            const label = $('.edit-field-label-input', form).val();
            
            // Text label elements require different actions
            if (field.hasClass('text-ctn')) {
                // Update text content (heading or decsription label)
                field.find('.text-content').text(label);
            } else {
                // Default inputs
                const inp = field.find('.form-input, .form-check-input, .form-input-upload-input');
                const isCheckbox = field.hasClass('form-checkbox-ctn');
                const nameInp = $('.edit-field-name-input', form);
                const required = $('.edit-field-required-input', form).prop('checked');

                if (!nameInp.val()) {
                    nameInp.addClass('error');
                    return false;
                }
                nameInp.removeClass('error');
                // Set field name and required class
                if (isCheckbox) {
                    const allCheckInputs = formEditor.find('.form-check-input[name=' + nameInp.val() + ']');
                    required ? allCheckInputs.addClass('required') : allCheckInputs.removeClass('required');
                } else {
                    required ? inp.addClass('required') : inp.removeClass('required');
                }
                // Set field label and required sign (*)
                if (label) {
                    field.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value').text(label);
                }
                // Set rich-text format on textarea
                if (inp.hasClass('textarea')) {
                    if ($('.edit-field-mce-input', form).prop('checked')) {
                        inp.addClass('mce-enabled');
                        initFormTextareaMCE();
                    } else {
                        inp.removeClass('mce-enabled');
                        if (tinymce.get(inp[0].name)) {
                            tinymce.get(inp[0].name).destroy();
                        }
                    }
                }
                // Set select options
                if (inp.hasClass('form-select')) {
                    inp.html('<option value=""></option>');
                    $('.edit-field-select-options-item input', form).each(function() {
                        if (this.value) {
                            inp.append('<option value="' + this.value + '">' + this.value + '</option>');
                        }
                    });
                }
                // Set file accept
                if (inp.attr('type') === 'file') {
                    inp.attr('accept', $('.edit-field-accept-input', form).val());
                }
            }
            
            currentEditFieldId = undefined;
            utilPopupClosePopup.call(this);
        });
        
        // Process and save form action
        $('.admin-forms-editor-save-btn').on('click', function(e) {
            // Checking current waiting state
            if (openLoadingWait()) {
                return false;
            }
            
            const settingsCtn = $('.admin-forms-editor-settings');
            // Validate required fields
            formValidator.validateForm(settingsCtn);
            if (settingsCtn.hasClass('has-error') || settingsCtn.has('.error')[0]) {
                return false;
            }
            
            const sets = [];
            fieldsetCtn.find('.fieldset:not(.last)').each(function(i, el) {
                const set = {
                    position: i,
                    fields: []
                };
                
                $('.input-ctn, .form-checkbox-ctn', el).each(function(j, ele) {
                    const $ele = $(ele);
                    const field = {
                        position: j,
                        spanClass: $ele.attr('data-span'),
                        type: $ele.attr('data-ctn')
                    };
                    let inp;
                    
                    if ($ele.hasClass('text-ctn')) {
                        // Save heading and description text
                        field.label = $ele.find('.text-content').text();
                    } else if ($ele.hasClass('form-checkbox-ctn')) {
                        // Save checkbox and radio info
                        inp = $ele.find('.form-check-input');
                        field.label = field.value = $ele.find('.form-check-input-value').text();
                    } else if ($ele.hasClass('form-input-upload')) {
                        // Save upload field info
                        inp = $ele.find('.form-input-upload-input');
                        field.label = $ele.find('.form-input-upload-input-label-value').text();
                        field.accept = inp.attr('accept');
                    } else {
                        // Save all other input field info
                        inp = $ele.find('.form-input');
                        field.label = $ele.find('.form-input-label').text();
                    }
                    if (inp) {
                        field.name = inp.attr('name');
                        field.required = inp.hasClass('required');
                        if (inp.hasClass('form-select')) {
                            field.items = inp.find('option:not(:empty)').map((i, e) => e.value).get();
                        }
                        if (inp.hasClass('textarea')) {
                            field.mceEnabled = inp.hasClass('mce-enabled');
                        }
                    }
                    // Add each field to the fields group
                    set.fields.push(field);
                });
                // Add a set/group to the final array
                sets.push(set);
            });
            
            const data = {
                ajax: true,
                id: formId,
                name: $('.admin-forms-form-name').val(),
                note: $('.admin-forms-form-note').val(),
                destination: $('.admin-forms-form-destination').val(),
                subject: $('.admin-forms-form-subject').val(),
                responderId: $('.admin-forms-form-responder').val(),
                fieldsets: JSON.stringify(sets)
            };
            
            $.ajax({
                url: "/action/manageGenForm",
                method: "POST",
                type: "POST",
                cache: false,
                data: data,
                success: function(response) {
                    if (response.match('success')) {
                        let q = removeQuery('new');
                        q = removeQuery('formId', q);
                        // Redirect
                        window.location.search = q;
                    } else {
                        alert(response);
                    }
                },
                error: function(response) {
                }
            });
        });
    }
    
    function makeSvgPencil() {
        return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="20.3px" height="20.3px" viewBox="0 0 20.3 20.3" xml:space="preserve"><path d="M11.1,3.6l5.6,5.6L5.6,20.3H0v-5.6L11.1,3.6z M4.9,18.6l1.2-1.2l-3.1-3.1l-1.2,1.2v1.4h1.7v1.7H4.9z M11.9,6.1    c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.2,0-0.2,0.1l-7.3,7.3C4,13.3,4,13.3,4,13.4c0,0.2,0.1,0.3,0.3,0.3c0.1,0,0.2,0,0.2-0.1l7.3-7.3    C11.8,6.3,11.9,6.2,11.9,6.1z M20.3,4.9c0,0.5-0.2,0.9-0.5,1.2l-2.2,2.2L12,2.7l2.2-2.2C14.5,0.2,14.9,0,15.4,0    c0.5,0,0.9,0.2,1.2,0.5l3.1,3.1C20.1,4,20.3,4.4,20.3,4.9z"></path></svg>';
    }
    
    function initFormTextareaMCE() {
        if (typeof tinymce !== 'object') {
            setTimeout(function () {
                initFormTextareaMCE();
            }, 500);
            return false;
        }
        
        tinymce.init({
            selector: '.mce-enabled',
            content_css: ['/static/css/tiny.css', '/shared/websites/www.pmi.com/assets/tinymce/content.css'],
            cache_suffix: '?v=0.2',
            language: $('html').attr('lang'),
            plugins: ['advlist autolink lists link charmap',
                'searchreplace visualblocks textcolor',
                'insertdatetime table contextmenu paste hr fullscreen'],
            menubar: false, //'edit insert format',
            statusbar: false,
            toolbar: 'undo redo styleselect fontsizeselect link unlink bold italic underline forecolor backcolor bullist numlist alignleft aligncenter alignright alignjustify ',
            relative_urls: false,
            remove_script_host: false,
            allow_script_urls: false,
            entity_encoding: 'numeric',
            force_br_newlines: false,
            paste_as_text: true,
            contextmenu: 'styleselect fontsizeselect | bold italic underline link | inserttable cell row column deletetable',
            theme_advanced_blockformats: 'p,h1,h2,h3,h4,h5,h6,blockquote',
            fontsize_formats: '8px 9px 10px 11px 12px 13px 14px 15px 16px 18px 20px 22px 24px 28px 30px 32px',
            toolbar_location: 'bottom',
            init_instance_callback: function(editor) {
                if (window.MiniBar) {
                    const el = editor.getContainer().querySelector('.mce-toolbar-grp .mce-flow-layout');
                    if (el.clientHeight > 10) {
                        $(el).css({
                            height: el.clientHeight + 'px',
                        });
                        new MiniBar(el, {
                            barType: 'default',
                            minBarSize: 5,
                            hideBars: false,
                            alwaysShowBars: false,
                            horizontalMouseScroll: true,
                            wheelScrollAmount: 3, // not working, it always scrolls too much
                            scrollX: true,
                            scrollY: false,
                        });
                    }
                }
            },
        });
        
    }
    
    function duplicateForm(e) {
        if (openLoadingWait()) {
            return false;
        }
        
        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                duplicate: true,
                id: $(e.currentTarget).data('id')
            },
            success: function(response) {
                if (response.match('success')) {
                    const id = response.slice('success-'.length);
                    // Redirect
                    window.location.search = setQuery('formId', id);
                } else {
                    alert(response);
                }
            },
            error: function(response) {
            }
        });
    }
    
    function deleteForm(e) {
        if (window.submittingForm) {
            return false;
        }
        window.submittingForm = true;
        
        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                delete: true,
                id: $(e.currentTarget).data('id')
            },
            success: function(response) {
                if (response.match('success')) {
                    // Reload page
                    window.location.reload();
                } else {
                    alert(response);
                }
            },
            error: function(response) {
            }
        });
    }
    
    function deleteFormSubmission(e) {
        if (window.submittingForm) {
            return false;
        }
        window.submittingForm = true;
        
        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                delete: true,
                submissionId: $(e.currentTarget).data('id')
            },
            success: function(response) {
                if (response.match('success')) {
                    // Reload page
                    window.location.reload();
                } else {
                    alert(response);
                }
            },
            error: function(response) {
            }
        });
    }


    function openLoadingWait() {
        const waiting = window.submittingForm;
        window.submittingForm = true;
        $('.popup-outer[data-id="loadingWait"]').addClass('open');
        return waiting;
    }

    function previewEventMedia() {
        if (!$('.event-media-preview')[0]) {
            return false;
        }
        
        $('.event-media-preview').each(function(i) {
            var newSrc = $(this).closest('.event-media-ctn').find('.event-media-source-input').val() || "";
            var curSrc = this.getAttribute('data-src') || "";

            if (newSrc !== curSrc) {
                this.innerHTML = '<img src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });

        setTimeout(previewEventMedia, 1000);
    }

    function previewJobMedia() {
        if (!$('.job-media-preview')[0]) {
            return false;
        }
        
        $('.job-media-preview').each(function(i) {
            var newSrc = $(this).closest('.job-media-ctn').find('.job-media-source-input').val() || "";
            var curSrc = this.getAttribute('data-src') || "";

            if (newSrc !== curSrc) {
                this.innerHTML = '<img class="job-logo" src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });

        setTimeout(previewJobMedia, 1000);
    }
	
	$(window).ready(function (e) {
		formValidator = Fw.component.models().form;
		tools = Fw.component.models().tools;
        utilPopupOpenPopup = Fw.component.models().popup.openPopup;
        utilPopupClosePopup = Fw.component.models().popup.closePopup;
		datepicker = $('.datepicker');
		promoTypeSelect = $('.promo-type-select');
		updateCCInfosBtn = $('.update-cc-infos-btn');
		jobImgBtn = $('.create-job-image-ctn .file-preview-picker-popup-accept-btn');
		attendedEventCheckbox = $('.admin-event-participants input[name="attended"]');
		allAttendedEventCheckbox = $('.admin-event-participants input[name="all-attended"]');
		applyCreditPopupBtn = $('.apply-credit-popup-btn');
		applyCreditConfirmBtn = $('.confirm-credit-btn');
		resendJobInvoiceBtn = $('.resend-job-invoice');
		formatLocationFields = $('.location-field');
		futureEventSelector = $(".registration-event-select:not(.registration-event-select-past)");

        if (formatLocationFields.length) {
            setTimeout(formatLocation, 1000);
        }
		if (datepicker.length) {
			initDatepickers();
		}
		promoTypeSelect.change(checkPromoType);
		updateCCInfosBtn.click(updateCCInfos);
		jobImgBtn.click(updateJobImgChoice);
		$('.admin-event-participants input[name="refunded"]').on('change', participantRefunded);
		attendedEventCheckbox.on('change', pmiAttended);
		allAttendedEventCheckbox.on('change', pmiAllAttended);
		applyCreditPopupBtn.click(applyCreditValidate);
		applyCreditConfirmBtn.click(applyCredit);
		resendJobInvoiceBtn.click(resendJobInvoice);
		$('.copy-event-url').click(copyUrlToClipboard);
        $('.check-events-form').click(validateEventForm);
        $('.add-expense-btn').click(resetExpenseForm);
        $('.edit-expense-btn').click(editExpense);
        $('.add-email-list-btn').click(resetEmailListForm);
        $('.edit-email-list-btn').click(editEmailList);
        $('.check-email-list-form').click(validateEmailListForm);
        $('.event-add-pdu').click(addEventPdu);
        $('.create-event-form .form-input[name=eventType]').on('change', eventTypeChange);
        
        if($('.background-picker-settings-ctn').length){
            $('.slick-slider').on('setPosition', imagePickerSlickSliderInit);
        }  
        
		if ($('.promocode-event-select').length) {
			loadPromoEvents();
		}
        if ($('.promocode-product-select').length) {
            loadPromoProducts();
        }
        
        previewLocationImage();
        previewEventMedia();
        previewJobMedia();

        if ($('.registration-event-select').length) {
            fetchEvents(e, futureEventSelector);
        }
        
        $('.sortquery').addClass('tablesorter-default')
            .find('th[data-sort-by]').addClass('tablesorter-header').click(sortByQuery);

        /* Initiate form builder functions */
        initFormBuilder();
        initFormTextareaMCE();
        
        $('.admin-form-duplicate').on('click', duplicateForm);
        $('.admin-form-delete-confirm').on('click', deleteForm);
        $('.admin-form-submission-delete-confirm').on('click', deleteFormSubmission);
	});
	
})(jQuery);
